import { createStore, select, withProps } from '@ngneat/elf';
import { Injectable } from '@angular/core';
import { Repository } from '@frontend-site/shared/utils';
import { FreeTextSearchState } from '@frontend-site/shared/data';
import { filter } from 'rxjs/operators';

function createInitialState(): FreeTextSearchState {
    return {
        searchedText: null,
        selectedRowsNodesIds: null
    };
}

@Injectable({
    providedIn: 'root'
})
export class FreeTextSearchRepository extends Repository<FreeTextSearchState> {
    constructor() {
        super(createStore({ name: 'free-text-search' }, withProps<FreeTextSearchState>(createInitialState())));
    }

    public readonly searchState$ = this.store.pipe(
        select((state: FreeTextSearchState) => state),
        filter((state) => !!state)
    );

    public updateFreeTextSearchState(freeTextSearchState: FreeTextSearchState): void {
        this.update(freeTextSearchState);
    }

    public resetSearchText(): void {
        const searchedText = null;
        this.update({ searchedText });
    }

    public resetSelectedRowsIds(): void {
        const selectedRowsNodesIds = null;
        this.update({ selectedRowsNodesIds });
    }

    public isFreeTextSearchState(state: { [p: string]: any } | undefined): state is FreeTextSearchState {
        const searchedText = state?.searchedText;
        const selectedRowsNodesIds = state?.selectedRowsNodesIds;
        return this.isSearchText(searchedText) && this.isSelectedRowsNodesIds(selectedRowsNodesIds);
    }

    private isSelectedRowsNodesIds(selectedRowsNodesIds: unknown): selectedRowsNodesIds is string[] | null {
        return (
            this.isNull(selectedRowsNodesIds) ||
            (Array.isArray(selectedRowsNodesIds) && selectedRowsNodesIds.every((id) => typeof id === 'string'))
        );
    }

    private isSearchText(searchedText: unknown): searchedText is string | null {
        return this.isNull(searchedText) || typeof searchedText === 'string';
    }

    private isNull(obj: unknown): obj is null {
        return typeof obj === null;
    }
}
